import { Heading } from '@awazevr/design-system.components.text'
import { CurrencyDisplay } from '@awazevr/design-system.utils.currency'
import type { FormattedAmount } from '@awazevr/mfe-common.utils.locale-formatting'

import { StyledPrice, StyledWasPrice } from './Pricing.styles'

const formatAmountWithSign = ({
  currencySign,
  currencySignPosition,
  formattedAmount,
}: FormattedAmount): string =>
  currencySignPosition === 'after'
    ? `${formattedAmount}${currencySign}`
    : `${currencySign}${formattedAmount}`

export type PricingProps = {
  fromPrice?: number | null
  price?: number | null
  wasPrice?: number | null
  formatCurrency: (value: number) => FormattedAmount
  wasPriceAriaLabel?: string
}

export const Pricing = ({
  fromPrice,
  price,
  wasPrice,
  formatCurrency,
  wasPriceAriaLabel = 'Previous price',
}: PricingProps): JSX.Element | null => {
  const fromPriceDisplay = fromPrice ? formatCurrency(fromPrice) : null
  const priceDisplay = price ? formatCurrency(price) : null
  const wasPriceDisplay = wasPrice ? formatCurrency(wasPrice) : null

  const displayed = fromPriceDisplay || priceDisplay

  if (!displayed && !wasPriceDisplay) return null

  return (
    <StyledPrice>
      <Heading as={'span'} sizes={200}>
        {displayed && (
          <CurrencyDisplay {...displayed}>
            {displayed.formattedAmount}
          </CurrencyDisplay>
        )}
      </Heading>
      {wasPriceDisplay && (
        <StyledWasPrice
          sizes={200}
          color="ColorStatusAttention400"
          aria-label={`${wasPriceAriaLabel} ${formatAmountWithSign(
            wasPriceDisplay,
          )}`}
        >
          <CurrencyDisplay {...wasPriceDisplay}>
            {wasPriceDisplay.formattedAmount}
          </CurrencyDisplay>
        </StyledWasPrice>
      )}
    </StyledPrice>
  )
}
